
import { Component } from '@angular/core'

@Component({
  selector: 'my-empty',
  template: ''
})
export class EmptyComponent {

}
